import { useState, useEffect, useContext } from 'react'
import { VoxSoftwaresContext } from '../../../contexts/voxSoftwaresProvider'
import DataTable from '../../Table'
import BaseSelect from '../../General/FormsComp/Select/BaseSelect'

const Consulta = ({ onNovoVinculo }) => {
  const context = useContext(VoxSoftwaresContext)
  const { clientes, vinculos, getVinculosByCliente, deleteVinculo, setAlert, selectedCliente, setSelectedCliente } = context
  const [vinculosFormatados, setVinculosFormatados] = useState([])


  useEffect(() => {
    // Garantir que vinculos seja sempre um array
    const vinculosArray = Array.isArray(vinculos) ? vinculos : []
    
    let vincFormatados = vinculosArray.map(vinc => {
      // Verificar se vinc existe e é um objeto válido
      if (!vinc || typeof vinc !== 'object') {
        return null
      }
      
      return {
        ...vinc,
        // Mapear sistema_externo para tipo (compatibilidade com código existente)
        tipo: vinc.sistema_externo || vinc.tipo || 'Desconhecido',
        // Mapear nome do software baseado no sistema_externo
        software_nome: vinc.sistema_externo === 'voxchat' ? 'Vox Chat' :
            vinc.sistema_externo === 'edutech' ? 'Edutech' : 
            vinc.sistema_externo || vinc.tipo || 'Sistema Desconhecido',
        // Formatar data
        data_vinculo: vinc.data_vinculo ? new Date(vinc.data_vinculo).toLocaleDateString('pt-BR') : 'N/A',
        // Formatar status
        ativo: vinc.ativo === 1 ? 'Ativo' : 'Inativo'
      }
    }).filter(vinc => vinc !== null) // Remover entradas nulas
    
    console.log('Vinculos originais:', vinculos)
    console.log('Vinculos formatados:', vincFormatados)
    setVinculosFormatados(vincFormatados)
  }, [vinculos])

  const excluirVinculo = (id) => {
    const vinculo = vinculosFormatados.find(v => String(v.id) === String(id))
    setAlert({
      type: 'confirm',
      // Card Edutech #35015: o vínculo do Edutech sai só do ERP.
      placeholder: vinculo && vinculo.sistema_externo === 'edutech' && vinculo.tenant_externo_id
        ? 'O vínculo sai do ERP e a prefeitura continua ativa no Edutech. Para inativar, peça ao suporte Vox.'
        : 'Deseja realmente excluir o vínculo? Esta ação é irreversível.',
      visible: true,
      confirm: true,
      title: 'Atenção!',
      callback: () => deleteVinculo(id),
      params: id
    })
  }

  const headers = [
    { label: "ID", key: "id", sortable: true },
    { label: "Cliente", key: "cliente_nome", sortable: true },
    { label: "Software", key: "software_nome", sortable: true },
    { label: "Data Vínculo", key: "data_vinculo", sortable: true },
    { label: "Status", key: "ativo", sortable: true },
    { label: "Tenant ID", key: "tenant_externo_id", sortable: true },
    { label: "Ações", key: "actions", sortable: false, actions: { "deletar": excluirVinculo } },
  ]

  const handleClienteChange = (e) => {
    const clienteId = e.target.value;
    if (clienteId) {
      const selectCliente = clientes.find(c => c.id == clienteId);
      if (selectCliente) {
        setSelectedCliente(selectCliente);
        getVinculosByCliente(selectCliente.id)
      }
    } else {
      setSelectedCliente(null);
    }
  }

  return (
    <div className="w-full p-5">
      <div className="flex gap-4 mb-5 items-center justify-between flex-wrap">
        <div className="flex-1 max-w-md">
          <BaseSelect
            label="Selecione um Cliente"
            name="cliente"
            value={selectedCliente?.id || ''}
            onChange={handleClienteChange}
            options={clientes || []}
            placeholder="Escolha um cliente..."
            valueKey="id"
            labelKey="nome"
            searchable={true}
          />
        </div>

        {selectedCliente && (
          <button
            onClick={() => onNovoVinculo(selectedCliente)}
            className="btn-vox-secondary flex items-center gap-2 mt-6"
          >
            <span>+</span>
            Novo Vínculo para {selectedCliente?.nome || selectedCliente?.razaosocial || 'este cliente'}
          </button>
        )}
      </div>

      {selectedCliente ? (
        vinculosFormatados.length > 0 ? (
          <DataTable
            headers={headers}
            data={vinculosFormatados}
            itemsPerPage={10}
            checkboxColumn={false}
          />
        ) : (
          <div className="text-center py-10 px-5 bg-gray-50 dark:bg-gray-800 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600">
            <p className="text-gray-600 dark:text-gray-400 text-base m-0">
              Nenhum vínculo encontrado para {selectedCliente?.nome || selectedCliente?.razaosocial || 'este cliente'}
            </p>
            <p className="text-gray-400 dark:text-gray-500 text-sm mt-2">
              Clique no botão "Novo Vínculo" no topo ou abaixo para criar o primeiro vínculo
            </p>
          </div>
        )
      ) : (
        <div className="text-center py-16 px-5 bg-gray-50 dark:bg-gray-800 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600">
          <p className="text-gray-600 dark:text-gray-400 text-lg m-0">
            Selecione um cliente para visualizar os vínculos
          </p>
        </div>
      )}
    </div>
  )
}

export default Consulta
